// extracted by mini-css-extract-plugin
export default {"partnerTitle":"styles_partnerTitle__CEOr0","partnerSubheader":"styles_partnerSubheader__-+1hJ"};